export const blockIconsPlacesStorefront = (
	<span className='material-symbols-outlined'>storefront</span>
);
